export default __webpack_public_path__ + "static/media/laptop-border.4415db56.svg";